import React, { useState, useEffect } from 'react';
import './index.css';
import logoName from '../../assets/icons/logoName.png';
import product from '../../assets/home/product.png';
import product2 from '../../assets/home/product2.png';
import product3 from '../../assets/home/product3.png';
import product4 from '../../assets/home/product4.png';
import product5 from '../../assets/home/product5.png';
import product6 from '../../assets/home/product6.png';
import product7 from '../../assets/home/product7.png';
import about1 from '../../assets/home/about1.png';
import about2 from '../../assets/home/about2.png';

const Home: React.FC = () => {
  const [activeNav, setActiveNav] = useState(1);

  // 处理导航点击（平滑滚动）
  const handleNavClick = (navItem: React.SetStateAction<number>, e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    setActiveNav(navItem);

    const sectionId = getSectionId(navItem);
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  const getSectionId = (navItem: any) => {
    switch (navItem) {
      case 1: return 'product';
      case 2: return 'about';
      case 3: return 'news';
      default: return 'product';
    }
  };

  return (
    <div className='divCon'>
      <nav className="navbar navbar-sticky">
        <div className="navbar-container">
          {/* logo */}
          <div className="navbar-brand">
            <img className='logoNameImg' src={logoName} alt='logo' />
          </div>
          {/* tab */}
          <div className="navbar-menu" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <a
              href="#product"
              className={`nav-item ${activeNav === 1 ? 'active' : ''}`}
              onClick={(e) => handleNavClick(1, e)}
            >
              产品</a>
            <a
              href="#about"
              className={`nav-item ${activeNav === 2 ? 'active' : ''}`}
              onClick={(e) => handleNavClick(2, e)}
            >
              关于新蹊</a>
            {/* <a
              href="#news"
              className={`nav-item ${activeNav === 3 ? 'active' : ''}`}
              onClick={(e) => handleNavClick(3, e)}
            >
              新闻</a> */}
          </div>
          {/* 占位 */}
          <div className="placeholderCon"></div>
        </div>
      </nav>
      {/* 内容区域 */}
      <main className="main-content" style={{
        maxWidth: activeNav === 2 ? '1100px' : ''
      }}>
        {activeNav === 1 && (
          <div className="image-gallery">
            <div className="image-container">
              <img className='product-img' src={product} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product2} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product3} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product4} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product5} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product6} />
            </div>
            <div className="image-container">
              <img className='product-img' src={product7} />
            </div>
          </div>
        )}
        {activeNav === 2 && (
          <div className="image-gallery">
            <div className="image-container">
              <img className='product-img' style={{ marginTop: '100px' }} src={about1} />
            </div>
            <div className="image-container">
              <img className='product-img' style={{ marginTop: '60px' }} src={about2} />
            </div>
          </div>
        )}
        {activeNav === 3 && (
          <div></div>
        )}
      </main>
      <div className='footer'>
        <div className='footer-content'>
          <div className='copyright'>
            杭州新蹊科技有限公司 Copyright © 2025 Al rights reserved
          </div>
          <div className='legal-info'>
            <div className='legal-item'>浙ICP备2025181172</div>
            {/* <div className='legal-item'>公安联网备案号：京公网安备11010502040641号</div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;